/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ComponentTypeStatus } from './ComponentTypeStatus';
import {
    ComponentTypeStatusFromJSON,
    ComponentTypeStatusFromJSONTyped,
    ComponentTypeStatusToJSON,
    ComponentTypeStatusToJSONTyped,
} from './ComponentTypeStatus';

/**
 * 
 * @export
 * @interface ComponentTypesResponseDto
 */
export interface ComponentTypesResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ComponentTypesResponseDto
     */
    id: string;
    /**
     * Name of the ComponentType
     * @type {string}
     * @memberof ComponentTypesResponseDto
     */
    name: string;
    /**
     * Status of the ComponentType
     * @type {ComponentTypeStatus}
     * @memberof ComponentTypesResponseDto
     */
    status?: ComponentTypeStatus;
    /**
     * List of synonyms for this ComponentType
     * @type {Array<string>}
     * @memberof ComponentTypesResponseDto
     */
    synonyms: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof ComponentTypesResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ComponentTypesResponseDto
     */
    updatedAt: Date;
}



/**
 * Check if a given object implements the ComponentTypesResponseDto interface.
 */
export function instanceOfComponentTypesResponseDto(value: object): value is ComponentTypesResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('synonyms' in value) || value['synonyms'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ComponentTypesResponseDtoFromJSON(json: any): ComponentTypesResponseDto {
    return ComponentTypesResponseDtoFromJSONTyped(json, false);
}

export function ComponentTypesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComponentTypesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'status': json['status'] == null ? undefined : ComponentTypeStatusFromJSON(json['status']),
        'synonyms': json['synonyms'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function ComponentTypesResponseDtoToJSON(json: any): ComponentTypesResponseDto {
    return ComponentTypesResponseDtoToJSONTyped(json, false);
}

export function ComponentTypesResponseDtoToJSONTyped(value?: ComponentTypesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'status': ComponentTypeStatusToJSON(value['status']),
        'synonyms': value['synonyms'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

